import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';

interface DashboardTitleProps {
  title: string;
  subtitle: string;
}

export const DashboardTitle: React.FC<DashboardTitleProps> = ({ title, subtitle }) => {
  return (
    <motion.div 
      className="glass p-8 relative overflow-hidden"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
    >
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-black/40 via-transparent to-neon-purple/5" />
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `
              linear-gradient(to right, rgba(0,255,148,0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(0,255,148,0.1) 1px, transparent 1px)
            `,
            backgroundSize: '20px 20px'
          }}
        />
      </div>

      <div className="relative flex items-center justify-between">
        <div>
          <motion.h1 
            className="text-6xl font-bold bg-gradient-to-r from-neon-green via-neon-purple to-neon-green bg-clip-text text-transparent mb-4"
            animate={{ 
              backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'] 
            }}
            transition={{ 
              duration: 5,
              repeat: Infinity,
              ease: "linear"
            }}
            style={{ backgroundSize: '200% auto' }}
          >
            {title}
          </motion.h1>
          <div className="text-xl text-gray-400 flex items-center space-x-3">
            <Zap className="w-5 h-5 text-neon-green" />
            <span>{subtitle}</span>
          </div>
        </div>
      </div>

      {/* Scan line effect */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-b from-transparent via-neon-green/10 to-transparent"
        animate={{
          y: ['-100%', '100%'],
        }}
        transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'linear',
        }}
        style={{ height: '2px' }}
      />
    </motion.div>
  );
};